<template>
  <div>
    <div class="page-title-area">
      <Banner :blogger="blogger" />
      <div class="container">
        <div class="articles" v-if="loading">
          <ArticleSecondSkeleton v-for="(article, i) in 3" :key="i" />
        </div>
        <div class="articles" v-else>
          <ArticleSecond
            :article="article"
            v-for="(article, i) in blogs"
            :key="i"
            :bookMarks="bookMarks"
            @bookMarkBlog="toggleBookMark"
            :show-blogger-profile="false"
          />
        </div>
      </div>
    </div>
    <Form />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Form from "@/components/layout/Form";
import Banner from "@/components/other-pages/crew/member/Banner";
import ArticleSecondSkeleton from "@/components/other-pages/Blogs/ArticleSecondSkeleton";
import ArticleSecond from "@/components/other-pages/Blogs/ArticleSecond";

export default {
  name: "blogger-blogs",
  data() {
    return {
      crewName: this.$route.params.crewName,
      blogger: {},
      ip: "",
      loading: false,
      blogs: [],
      bookMarks: []
    };
  },
  components: {
    ArticleSecond,
    ArticleSecondSkeleton,
    Banner,
    Form
  },
  watch: {
    crewName(newValue, oldValue) {
      this.getBlogger();
    },
    user(newValue, oldValue) {
      if (newValue.uid) {
        this.getBookMarks();
      }
    }
  },
  computed: {
    ...mapGetters({
      user: "user/user"
    })
  },
  beforeMount() {
    this.loading = true;
  },
  mounted() {
    this.getBlogger();
    this.getBookMarks();
  },
  methods: {
    getBlogger() {
      this.blogger = {};
      this.$store
        .dispatch(
          "listings/getBloggerByProfileName",
          this.$route.params.crewName
        )
        .then(res => {
          this.blogger = res;
          this.getBlogs(this.blogger.id);
        })
        .catch(e => {
          console.log(e);
        });
    },
    getBlogs(id) {
      this.$store.dispatch("listings/getBlogsByBloggerId", id).then(blogs => {
        this.loading = false;
        this.blogs = blogs;
      });
    },
    getBookMarks() {
      if (this.user) {
        this.$store
          .dispatch("user/getUserBlogBookMarks", this.user.uid)
          .then(bookMarks => {
            this.bookMarks = bookMarks;
          });
      }
    },
    toggleBookMark(data) {
      console.log(data);
      if (!this.user) {
        this.$bvModal.show("loginModal");
      } else {
        if (data.type == "add") {
          this.$store.dispatch("user/addBookMarkBlog", data.blog).then(() => {
            this.getBookMarks();
            console.log("Bookmarked");
          });
        } else {
          this.$store
            .dispatch("user/removeBookMarkBlog", data.blog)
            .then(() => {
              this.getBookMarks();
              console.log("Removed bookmark");
            });
        }
      }
    }
  }
};
</script>
<style scoped>
.container {
  position: relative;
}
.page-title-area {
  background: none;
  padding-top: 72px;
  padding-bottom: 20px;
}
.articles {
  padding: 2rem 3rem;
}
.btn {
  text-transform: uppercase;
  font-weight: 600;
  font-size: 16px;
  letter-spacing: 0.05em;
  padding: 9px 18px 0px 16px;
  width: 120px;
}
.related-users {
  margin-top: 30px;
}
.related-header {
  display: flex;
}
.related-header h1 {
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  color: #52595e;
  margin-right: 22px;
}
.related-header span {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: #557efb;
  cursor: pointer;
}
/* .video-btn:hover {
  color: #fff;
  background: #557efb;
  box-shadow: 0 13px 27px 0 rgba(85, 126, 251, 0.75);
} */
.video-btn::after,
.video-btn::before {
  content: none;
  /* background: #557efb; */
}
/* .btn::before {
  border-radius: 0 32px 32px 0;
}
.btn::after {
  border-radius: 32px 0 0 32px;
} */
</style>
